'use client';
import React from 'react';
import Link from 'next/link';
import { Button } from '@components/ui/button';
import { cn } from '@lib/utils';
import { PhotoPackList } from '@components/Train/PhotoPackList';
interface PackTheme {
  name: string;
  slug: string;
  imageUrl: string;
}

interface PacksProps {
  className?: string;
  customThemes?: PackTheme[];
}

export default function Packs({ className }: PacksProps) {
  return (
    <div className={cn('relative bg-purple-500/0 justify-center flex flex-col items-center', className)}>
      <div className="">
        <div className="mx-auto max-w-2xl text-center items-center justify-center flex flex-col mb-10">
          <h2 className="text-4xl font-bold tracking-tight text-studio-900 sm:text-6xl">Hundreds of styles</h2>
          <p className="mt-6 text-lg leading-8 text-studio-600 max-w-lg w-full mb-10">
            Get photos in a variety of styles and themes. Choose from our selection of packs to get started.
          </p>
          <div className="flex items-center justify-center gap-x-6">
            <Button
              className=""
              variant={'accent'}
              size={'xl'}
              asChild
              data-element-location="packs_section"
              data-cta-type="accent"
              data-element-text="Browse packs"
            >
              <Link href="/packs/browse">Browse photo packs</Link>
            </Button>
          </div>
        </div>
      </div>
      <PhotoPackList
        sortBy="TOP"
        tags={['corporate']}
        limit={8}
        listTitle="Popular Photo Packs"
        variant="samples"
        showUsageCount={false}
        mode="cart"
      />
    </div>
  );
}
